@if (details) {
  <table mat-table [dataSource]="dataSource" class="mat-elevation-z2">
    <ng-container matColumnDef="taskNumber">
      <th mat-header-cell *matHeaderCellDef> Ordre ID </th>
      <td mat-cell *matCellDef="let element">
        @if (element?.kind === 'group') {
          <span class="group-toggle">
            <span class="group-label">{{element.order.taskNumber}} ({{element.children.length}})</span>
            <mat-icon>{{element.expanded ? 'expand_less' : 'expand_more'}}</mat-icon>
          </span>
        } @else {
          <span [class.child-indent]="element?.kind === 'child'">{{element?.order.taskNumber}}</span>
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="customerAndTask">
      <th mat-header-cell *matHeaderCellDef> Kunde/opgave </th>
      <td mat-cell *matCellDef="let element"> {{element?.order.customerAndTask}} </td>
    </ng-container>
    <ng-container matColumnDef="personalRevenue">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element" class="right-align">
        @if (type === 'personalRevenue') { {{$safeNavigationMigration(element?.amount) | number: '1.0-0'}} }
      </td>
    </ng-container>
    <ng-container matColumnDef="invoicedPersonalRevenue">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element" class="right-align">
        @if (type === 'invoicedPersonalRevenue') { {{$safeNavigationMigration(element?.amount) | number: '1.0-0'}} }
      </td>
    </ng-container>
    <ng-container matColumnDef="weightedPipeline">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element" class="right-align">
        @if (type === 'weightedPipeline') { {{$safeNavigationMigration(element?.amount) | number: '1.0-0'}} }
      </td>
    </ng-container>
    <ng-container matColumnDef="leads">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element" class="right-align">
        @if (type === 'leads') { {{$safeNavigationMigration(element?.amount) | number: '1.0-0'}} }
      </td>
    </ng-container>
    <ng-container matColumnDef="realizedSales">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element" class="right-align">
        @if (type === 'realizedSales') { {{$safeNavigationMigration(element?.amount) | number: '1.0-0'}} }
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="toggle(row)"
      [class.group-row]="row.kind === 'group'" [class.expanded-group-row]="row.kind === 'group' && row.expanded"
      [class.child-row]="row.kind === 'child'"></tr>
  </table>
}